// Put number into locale format. Example for US locale: "1234567" becomes "1,234,567"
const formatNumber = number => {
	const parsedNum = Number.parseInt(number, 10);
	return !Number.isNaN(parsedNum) ? parsedNum.toLocaleString() : '';
};

export default formatNumber;
